import { loadingAction } from "ReduxReducers/loadingReducer";
import axios from "axios";
import { appConstants } from "./appConstants";
import { IdleAction } from "ReduxReducers/tokenGenerateTime";
import { generateToken } from "./generic";
let axiosConfig = {
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
  },
};
let id;
if (JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")) !== null) {
  id = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))._id;
}

/*<=======================================ADMIN DASHBOARD================================>*/

export const getSuperAdminDashboardData = async (callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .get(
      appConstants.baseURL + "dashboard/fetchSuperAdminDashboardData",
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getSuperAdminDashboardData===>", error);
    });
};

export const getSuperAdminDasboardBarChartData = async (callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .get(
      appConstants.baseURL + "dashboard/fetchSuperAdminDasboardBarChartData",
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getSuperAdminDasboardBarChartData===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getSuperAdminDasboardLineChartData = async (
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .get(
      appConstants.baseURL + "dashboard/fetchSuperAdminDasboardLineChartData",
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getSuperAdminDasboardLineChartData===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getSuperAdminDasboardLineChartDataRevenue = async (
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .get(
      appConstants.baseURL +
        "dashboard/fetchSuperAdminDasboardLineChartDataRevenue",
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getSuperAdminDasboardLineChartDataRevenue===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getSuperAdminDasboardActivityData = async (callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .get(
      appConstants.baseURL + "dashboard/fetchSuperAdminDasboardActivityData",
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getSuperAdminDasboardActivityData===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getDasboardSuperAdminGridData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "dashboard/fetchDasboardSuperAdminGridData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getDasboardSuperAdminGridData===>",
        error?.response?.data?.Result_Message
      );
    });
};

/*<========================================BUSINESS USERS===================================>*/

export const getClients = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "clients/fetchClients", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getClients===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getSelectedClients = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "clients/fetchSelectedClients",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getSelectedClients===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getClientPlanFeatures = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "clients/fetchClientPlanFeatures",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getClientPlanFeatures===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getSubsciptionTransactions = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "clients/fetchSubsciptionTransactions",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getSubsciptionTransactions===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getInvoicesAndPayments = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "clients/fetchInvoicesAndPayments",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getInvoicesAndPayments===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getClientUsers = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "clients/fetchClientUsers",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getClientUsers===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const businessdeleteRow = async (
  values,
  apiPath,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + apiPath, values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  businessdeleteRow===>", error.message);
    });
};

/*<===================================REPORTS=============================>*/

export const getClientReport = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "reports/fetchClientReport",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getClientReport===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getSubcriptionPlan = async (values, callBack, dispatch) => {
  axios
    .post(
      appConstants.baseURL + "reports/fetchSubcriptionPlan",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch(async (error) => {
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getSubcriptionPlan===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getInvoicRevenueReport = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "reports/fetchInvoicRevenueReport",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getInvoicRevenueReport===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getPaymentAndRevenueReport = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "reports/fetchPaymentAndRevenueReport",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getPaymentAndRevenueReport===>",
        error?.response?.data?.Result_Message
      );
    });
};

/*<===============================PARAMETER==============================>*/

export const getParameter = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameter/fetchParameter",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getParameter===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const saveParameter = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "parameter/addParameter", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error saveParameter===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const updateParameterByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameter/updateParameter",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error updateParameterByID===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getParameterList = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameter/fetchParameterList",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getParameterList===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getParameterById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameter/fetchParameterById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getParameterById===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const deleteParameterListByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameter/deleteParameterList",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error deleteParameterListByID===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const deleteParameterByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameter/deleteParameter",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error deleteParameterByID===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getParameterListById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameter/fetchParameterListById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getParameterListById===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const saveParameterList = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameter/addParameterList",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error saveParameterList===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const updateParameterListByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameter/updateParameterList",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error updateParameterListByID===>",
        error?.response?.data?.Result_Message
      );
    });
};

/*<===============================PARAMETER SETTING ==============================>*/

export const fetchParameterSettings = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameterSetting/fetchParameterSettings",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete fetchParameterSettings===>", error.message);
    });
};

export const deleteParameterSettingsRecords = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameterSetting/deleteParameterSettings",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete deleteParameterSettings===>", error.message);
    });
};

export const getParameterSettingById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameterSetting/fetchParameterById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete fetchParameterById===>", error.message);
    });
};

export const addParameterSettingsData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameterSetting/addParameterSettings",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete addParameterSettings===>", error.message);
    });
};

export const updateParameterSettingsData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameterSetting/updateParameterSettings",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete updateParameterSettings===>", error.message);
    });
};

/*<===============================TEMPLATE==============================>*/

export const fetchTemplate = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "template/fetchTemplate", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error fetchTemplate===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getTemplateById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "template/fetchTemplateById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete fetchTemplateById===>", error.message);
    });
};

export const addTemplateData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "template/addTemplates", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete addTemplates===>", error.message);
    });
};

export const updateTemplateData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "template/updateTemplate", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete updateTemplate===>", error.message);
    });
};

/*<===============================STANDARDFEATURES==============================>*/

export const fetchStandardFeatures = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/fetchStandardFeatures",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error fetchStandardFeatures===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const deleteStandardFeatureRecords = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/deleteStandardFeature",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete deleteStandardFeature===>", error.message);
    });
};

export const getStandardFeatureById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/fetchStandardFeatureById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete fetchStandardFeatureById===>", error.message);
    });
};

export const updateStandardFeatureData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/updateStandardFeature",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete updateStandardFeature===>", error.message);
    });
};

//========> SUBSCRIPTION PLAN features API ===========//

export const fetchSubscriptionPlan = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/fetchSubscriptionPlan",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error fetchSubscriptionPlan===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const deleteSubscriptionPlanRecords = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/deleteSubscriptionPlan",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete deleteSubscriptionPlan===>", error.message);
    });
};

export const getSubscriptionPlanById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/fetchSubscriptionPlanById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete fetchSubscriptionPlanById===>", error.message);
    });
};

export const addSubscriptionPlanData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/addSubscriptionPlan",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete addSubscriptionPlan===>", error.message);
    });
};

export const updateSubscriptionPlanData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/updateSubscriptionPlan",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete updateSubscriptionPlan===>", error.message);
    });
};

export const fetchPlanFeatures = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/fetchPlanFeatures",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error fetchPlanFeatures===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const fetchPlanNames = async (values, callBack) => {
  await axios
    .post(
      appConstants.baseURL + "subscriptionPlan/fetchPlanNames",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete fetchPlanNames===>", error.message);
    });
};

export const fetchFeatureNames = async (values, callBack) => {
  await axios
    .post(
      appConstants.baseURL + "subscriptionPlan/fetchFeatureNames",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete fetchFeatureNames===>", error.message);
    });
};

export const deletePlanFeatureRecords = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/deletePlanFeature",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete deletePlanFeature===>", error.message);
    });
};

export const getPlanFeatureById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/fetchPlanFeatureById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete fetchPlanFeatureById===>", error.message);
    });
};

export const addPlanFeatureData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/addPlanFeature",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete addPlanFeature===>", error.message);
    });
};

export const updatePlanFeatureData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "subscriptionPlan/updatePlanFeature",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete updatePlanFeature===>", error.message);
    });
};

//========> User API ===========//

export const fetchUser = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "user/fetchUser", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error fetchUser===>", error?.response?.data?.Result_Message);
    });
};

export const deleteUserRecords = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "user/deleteUser", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete deleteUser===>", error.message);
    });
};

export const getUserById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "user/fetchUserById", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete fetchUserById===>", error.message);
    });
};

export const addUserData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "user/addNewUser", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete addWarehouse===>", error.message);
    });
};

export const updateUserData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "user/updateUser", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete updateUser===>", error.message);
    });
};

export const fetchRolesData = async (values, callBack) => {
  await axios
    .post(appConstants.baseURL + "user/fetchRoles", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete getCountry===>", error.message);
    });
};

//========> Role API ===========//

export const addRoleData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "roles/addRole", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete addRole===>", error.message);
    });
};

export const updateRoleData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "roles/updateRole", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete updateRole===>", error.message);
    });
};

export const deleteRoleRecords = async (values, callBack, dispatch, errorCallBack) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "roles/deleteRole", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      errorCallBack?.(error);
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete deleteRole===>", error.message);
    });
};

export const fetchRoles = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "roles/fetchRoles", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete fetchRoles===>", error.message);
    });
};

export const getRoleById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "roles/fetchRoleById", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete fetchRoleById===>", error.message);
    });
};

export const fetchRoleRights = async (values, callBack) => {
  await axios
    .post(appConstants.baseURL + "roles/fetchRoleRights", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete fetchRoleRights===>", error.message);
    });
};

export const updateRoleRights = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  await axios
    .post(appConstants.baseURL + "roles/updateRoleRights", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete fetchRoleRights===>", error.message);
    });
};

export const deactivateClient = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "clients/deactivateClient",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error deactivateClient===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const reactivateAccount = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "clients/reactivateClientAccount",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error reactivateAccount===>",
        error?.response?.data?.Result_Message
      );
    });
};
